import { useEffect, useSyncExternalStore } from 'react';

import { disableAnalytics } from '@/lib/analytics';
import { disableMicrosoftClarity } from '@/lib/clarity';
import { readCookieConsent, subscribeToCookieConsent } from '@/lib/cookie-consent';

export function GoogleTagManager() {
  const consent = useSyncExternalStore(subscribeToCookieConsent, readCookieConsent, () => null);

  useEffect(() => {
    if (consent !== 'declined') return;
    if (disableAnalytics() || disableMicrosoftClarity()) window.location.reload();
  }, [consent]);

  return null;
}
